import * as React from 'react';
import { memo } from 'react';

const SvgUserV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("circle", { cx: 8.988, cy: 3.544, r: 2.9, stroke: "currentColor", strokeWidth: 1.2 }),
    React.createElement("path", { d: "M15.97 14.136H2.027a.5.5 0 0 1-.5-.5v-1.053c0-.105.033-.208.098-.291.159-.205.486-.605.793-.844 1.03-.801 1.96-.919 3.284-1.159.854-.154 1.79-.193 2.66-.22a20.46 20.46 0 0 1 1.678 0c.732.028 2.136.207 2.233.22l.01.001c.117.013 1.998.237 3.206 1.158.308.235.673.628.86.835.079.088.12.203.12.322v1.031a.5.5 0 0 1-.5.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
const Memo = memo(SvgUserV2);

export { Memo as default };
